import { Treturn, useFetch } from "@4uhub/lib4uhub";
import {
  createIpm,
  getIpmById,
  updateIpmById,
} from "../../../../../services/ipm.service";
import { useCallback } from "react";
import { TRelationShipForm, relationShipSchema } from "./RelationShipSchema";
import { RelationShipFormScreen } from "../../../../../screens/RelationshipsScreens/RelationShipFormScreen/RelationShipFormScreen";

const RelationShipForm = () => {
  const { sendRequest: save, loading: sLoading } = useFetch(createIpm);

  const { sendRequest: update, loading: uLoading } = useFetch(updateIpmById);

  const { sendRequest: get, loading: gLoading } = useFetch(getIpmById);

  const saveHandler = (v: TRelationShipForm) =>
    save({
      ...v,
      directionTypeId: v.directionType.id,
      setRelationshipTypeId: v.setRelationshipType.id,
    });

  const updateHandler = (v: TRelationShipForm, id: string) =>
    update({
      item: {
        ...v,
        directionTypeId: v.directionType.id,
        setRelationshipTypeId: v.setRelationshipType.id,
      },
      id: id,
    });

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TRelationShipForm>> => {
      const { data, success } = await get(id);

      if (data) {
        const newData: TRelationShipForm = {
          ...data,
          originName: data.originName ?? "",
          originValue: data.originValue ?? "",
          destinyName: data.destinyName ?? "",
          destinyValue: data.destinyValue ?? "",
        };
        return { data: newData, success: true };
      }
      return { data, success };
    },
    [get],
  );

  const loading = sLoading || uLoading || gLoading;

  return (
    <RelationShipFormScreen<TRelationShipForm>
      saveHandler={saveHandler}
      updateHandler={updateHandler}
      getHandler={getHandler}
      schema={relationShipSchema}
      loading={loading}
    />
  );
};

export default RelationShipForm;
